<template>
    <div class="nnoticia_wrapper">
      <div class="nnoticia_content">
        <a :href="url" class="noticia_img"
           :style="{
              backgroundImage: `url(${imagem})`
          }"/>
        <a :href="url" class="noticia_title">
          {{ titulo }}
        </a>
      </div>
    </div>
</template>

<script>
export default {
  name: "NoticiaElem",
  props:["imagem","titulo","url"]
}
</script>

<style scoped>
/*723-748*/
.noticia_img{
  height: 0;
  padding: 0 0 64%;
  background-position: top center;
  background-size: 100%;
  background-repeat: no-repeat;
  display: block;
  position: relative;
}

.noticia_img:after{
  -webkit-transition: opacity .5s ease-in-out;
  transition: opacity .5s ease-in-out;
  content: "";
  position: absolute;
  height: 0;
  padding: 0;
  padding-bottom: 64%;
  background-position: top center;
  background-size: 100%;
  background-color: #000;
  opacity: 0.1;
  width: 100%;
}

.noticia_img:hover:after{
  opacity: 0.6;
  -webkit-transition: opacity .5s ease-in-out;
  transition: opacity .5s ease-in-out;
}

/*754-767*/
.noticia_title{
  display: block;
  margin-top: 20px;
  margin-left: 5px;
  padding-top: 3px;
  font-size: 19px;
  font-family: "Montserrat SemiBold";
  color: #454648;
  padding-right: 10px;
  padding-left: 10px;
  letter-spacing: inherit;
}
.noticia_title:hover{
  color: black;
}

/*871-884*/
.nnoticia_wrapper{
  border: 1px solid white;
  background: white;
  margin-bottom: 27px;
  box-shadow: 2px 4px 17px -8px #928888ba;
}

.nnoticia_content{
  border: 1px solid white;
  margin: 8px;
  margin-bottom: 55px;
}

.nnoticia_wrapper:hover {
  box-shadow: 2px 4px 17px -6px rgb(16 13 13 / 73%);
  cursor: pointer;
}


@media only screen and (max-width: 1439px) {
  /*1066*/
  .nnoticia_content {
    margin-bottom: 30px;
  }

  /*1070*/
  .noticia_title {
    font-size: 17.5px;
    line-height: 1.75;
  }
}

@media (min-width : 768px) and (max-width : 1024px) {
  /*1349*/
  .nnoticia_content{
    /*display: flex;
    flex-direction: row;*/
    margin-bottom: 8px;
  }
  /*1355*/
  .nnoticia_content a{
    /*width: 50%;
    flex: 1 50%;
    max-width: 50%;*/
    width: 100%;
    flex: 1 100%;
    max-width: 100%;
    display: flex;
  }

  /*1362*/
  /*.noticia_img{
    padding-bottom: 32%;
  }*/
  /*1366*/
  .noticia_img:after{
  }
  /*1369*/
  .noticia_title {
    color: #454648;
    margin-top: 20px;
    font-size: 16px;
    line-height: 1.85;
    padding-right: 20px;
    padding-left: 20px;
  }

  /*1384*/
  .nnoticia_wrapper {
    margin-right: 0px!important;
  }
}

@media (max-width: 1500px) {
  .nnoticia_content {
    margin-bottom: 60px;
  }

   .noticia_title {
      line-height: 1.6;
    }



}




@media (max-width: 767px) {
  /*1707*/
  .nnoticia_wrapper {
    margin-right: 0!important;
  }

  /*1716*/
  .nnoticia_content {
    margin: 5px!important;
  }

  /*1720*/
  .noticia_title {
    color: #454648;
    margin-top: 20px;
    font-size: 15px;
    margin-bottom: 25px;
    line-height: 1.4;
  }

  .noticia_img {
    padding: 0 0 44%;
  }

  .noticia_img:after {
    padding-bottom: 44%;
  }

  .nnoticia_wrapper {
    margin-bottom: 5px;
  }




}

</style>